export const TermsOfService = () => (
  <div className="p-4 text-16 w-full text-center">
    <a target="_blank" href="/data/CGU_FREE_TRANSFERT_080223.pdf" className="font-semibold text-status-info underline">
      Consulter les Conditions Générales d'Utilisation du service Free Transfert
    </a>
    <p className="text-center text-12 mt-2">Dernière mise à jour : 08/02/2023</p>
  </div>
)
